"use strict";

(function () {
  'use strict';

  function cancelledTrips() {
    return function (arr) {
      if (arr && Array.isArray(arr)) {
        return arr.filter(function (item) {
          return item.cancelDate;
        });
      } else {
        return arr;
      }
    };
  }

  cancelledTrips.$inject = [];
  angular.module('filter.cancelled-trips', []).filter('cancelledTrips', cancelledTrips);
})();